// extracted by mini-css-extract-plugin
module.exports = {"baseMenu":"BaseMenu_baseMenu__ybXak","baseMenu--open-right":"BaseMenu_baseMenu--open-right__MWH0Y"};